export default __webpack_public_path__ + "static/media/artdi.c95f3fae.jpeg";